
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    FaHome,
    FaFileInvoiceDollar,
    FaFileAlt,
    FaSignOutAlt,
    FaUserCog,
    FaUsers,
    FaPrayingHands,
    FaStar,
    FaOm,
    FaCalendarAlt,
    FaBan,
    FaLock,
    FaPrint,
    FaChartBar,
    FaChevronDown,
    FaBars,
    FaTimes,
    FaReceipt,
    FaCoins,
    FaShieldAlt
} from "react-icons/fa";

import templeIcon from "../../assets/images/temple_icon.png";
import { logout, logoutUser } from "../../services/auth.service";

import "./navbar.css";
import "../../static/buttons.css";

const Navbar = () => {

    const navigate = useNavigate();

    const roleName = localStorage.getItem("roleName");
    const empName = localStorage.getItem("empName");
    const username = localStorage.getItem("username");

    const [menuOpen, setMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const isAdmin = roleName === "ROLE_ADMIN";
    const isUser = roleName === "ROLE_USER";

    const handleNavigate = (path) => {
        navigate(path);
        setMenuOpen(false);
        setActiveDropdown(null);
    };

    const handleLogout = async () => {
        await logoutUser();
        logout("L");
        navigate("/login", { replace: true });
    };

    const toggleDropdown = (menu) => {
        setActiveDropdown((previous) =>
            previous === menu ? null : menu
        );
    };

    const adminMenus = [
        { label: "Manage User", path: "/user-list", icon: <FaUsers /> },
        { label: "Manage Pooja", path: "/pooja-list", icon: <FaPrayingHands /> },
        { label: "Manage Ja Tha Pra", path: "/ja-tha-pra", icon: <FaOm /> },
        { label: "Manage Nakshatra", path: "/nakshatra-list", icon: <FaStar /> },
        { label: "Manage Gotra", path: "/gotra-list", icon: <FaStar /> },
        { label: "Manage Prathana", path: "/prathana-mandir", icon: <FaPrayingHands /> },
        { label: "Manage Ekadasi", path: "/ekadasi", icon: <FaCalendarAlt /> },
        { label: "Payment Transactions", path: "/payment-transactions", icon: <FaFileInvoiceDollar /> },
        { label: "Audit Stamping", path: "/audit-stamping", icon: <FaShieldAlt /> },
        { label: "Cancel Receipts", path: "/cancel-receipt", icon: <FaBan /> },
        { label: "Change Password", path: "/change-passsword", icon: <FaLock /> }
    ];

    const receiptMenus = [
        { label: "Generate Receipts", path: "/generate-receipts", icon: <FaReceipt /> },
        { label: "Kanike Receipts", path: "/kanika-receipts", icon: <FaCoins /> },
        { label: "Prathana Receipts", path: "/prathana-receipts", icon: <FaPrayingHands /> },
        ...(isAdmin
            ? [{ label: "Print Receipt", path: "/print-receipts", icon: <FaPrint /> }]
            : []),
        ...(isUser
            ? [
                { label: "Receipt List", path: "/user-receipts", icon: <FaFileInvoiceDollar /> },
                { label: "Change Password", path: "/change-passsword", icon: <FaLock /> }
            ]
            : [])
    ];

    const reportMenus = [
        { label: "Daily Reports", path: "/daily-reports", icon: <FaChartBar /> },
        { label: "Periodical Report", path: "/periodic-reports", icon: <FaCalendarAlt /> },
        { label: "Daily Pooja Report", path: "/daily-pooja-reports", icon: <FaPrayingHands /> },
        { label: "Daily Seva Collection Report", path: "/daily-seva-collection", icon: <FaCoins /> },
        { label: "Collection Details Report", path: "/collection-details-reports", icon: <FaFileAlt /> },
        { label: "SevaWise Report", path: "/sevawise-reports", icon: <FaChartBar /> }
    ];


    const renderDropdown = (title, icon, menuKey, items) => (
        <li
            className={`nav-item dropdown ${activeDropdown === menuKey ? "show" : ""
                }`}
            onMouseEnter={() => {
                if (window.innerWidth > 991) {
                    setActiveDropdown(menuKey);
                }
            }}
            onMouseLeave={() => {
                if (window.innerWidth > 991) {
                    setActiveDropdown(null);
                }
            }}
        >
            <button
                type="button"
                className="nav-link navbar-menu-button"
                onClick={() => {
                    if (window.innerWidth <= 991) {
                        toggleDropdown(menuKey);
                    }
                }}
                aria-expanded={activeDropdown === menuKey}
            >
                {icon}
                <span>{title}</span>
                <FaChevronDown className="dropdown-arrow" />
            </button>

            <ul
                className={`dropdown-menu ${activeDropdown === menuKey ? "show" : ""
                    }`}
            >
                {items.map((item) => (
                    <li key={item.path}>
                        <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleNavigate(item.path)}
                        >
                            <span className="dropdown-item-icon">
                                {item.icon}
                            </span>
                            <span>{item.label}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </li>
    );


    return (
        <nav className="navbar navbar-expand-lg navbar-dark divine-navbar">

            <div className="container-fluid navbar-container">

                {/* Brand */}
                <button
                    type="button"
                    className="navbar-brand d-flex align-items-center"
                    onClick={() => handleNavigate("/dashboard")}
                >
                    <span className="temple-logo-wrapper">
                        <img
                            src={templeIcon}
                            alt="Temple Logo"
                            className="temple-logo"
                        />
                    </span>

                    <span className="welcome-text">
                        <span className="welcome-small">Welcome To Temple Management System</span>
                        <span className="welcome-title">
                            {empName ? empName : username ? username : "User"}
                        </span>
                    </span>
                </button>

                {/* Mobile Toggle */}
                <button
                    className="navbar-toggler custom-navbar-toggler"
                    type="button"
                    onClick={() => {
                        setMenuOpen(!menuOpen);
                        setActiveDropdown(null);
                    }}
                    aria-label="Toggle navigation"
                    aria-expanded={menuOpen}
                >
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>

                {/* Navigation */}
                <div className={`navbar-collapse ${menuOpen ? "show" : ""}`}>

                    <ul className="navbar-nav ms-auto align-items-lg-center">

                        {/* Home */}
                        <li className="nav-item">
                            <button
                                type="button"
                                className="nav-link navbar-menu-button"
                                onClick={() => handleNavigate("/dashboard")}
                            >
                                <FaHome />
                                <span>Home</span>
                            </button>
                        </li>

                        {/* Admin */}
                        {isAdmin &&
                            renderDropdown(
                                "Admin",
                                <FaUserCog />,
                                "admin",
                                adminMenus
                            )
                        }

                        {/* Receipts */}
                        {renderDropdown(
                            "Receipts",
                            <FaFileInvoiceDollar />,
                            "receipts",
                            receiptMenus
                        )}

                        {/* Reports */}
                        {isAdmin &&
                            renderDropdown(
                                "Reports",
                                <FaFileAlt />,
                                "reports",
                                reportMenus
                            )
                        }

                        {/* Logout */}
                        <li className="nav-item logout-item">
                            <button
                                type="button"
                                className="nav-link navbar-menu-button logout-button"
                                onClick={handleLogout}
                            >
                                <FaSignOutAlt />
                                <span>Logout</span>
                            </button>
                        </li>

                    </ul>
                </div>

            </div>
        </nav>
    );
};

export default Navbar;
